import React, { useEffect } from "react";
import lottie from "lottie-web";
import { useSelector, useDispatch } from "react-redux";
import { setSoundAction, playSoundAction, clearSoundAction } from "../../../../../redux/sound";

const OXPopup = () => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setSound = payload => { dispatch( setSoundAction( payload ) ) };
  const playSound = () => { dispatch( playSoundAction() ) };
  const clearSound = () => { dispatch( clearSoundAction() ) };

  useEffect( () => {
    const animation = lottie.loadAnimation( {
      container : document.querySelector( '#answer_correct' ),
      path : `${ process.env.PUBLIC_URL }/static/json/${ answeringQuestions.isAnswer ? 'answer_correct' : 'answer_wrong' }.json`,
      renderer : 'svg',
      loop : false,
      autoplay : true
    } );
    animation.setSpeed( 0.65 );
    setSound( { src : `${ process.env.PUBLIC_URL }/static/audio/${ answeringQuestions.isAnswer ? 'lc_05_03_correct' : 'lc_05_03_wrong' }.ogg` } );
    playSound();
    return () => {
      animation.destroy();
      clearSound();
    };
  }, [ answeringQuestions.isAnswer ] );

  return (
    <div className="la-wrap">
      <div className="la-ani">
        <div id="answer_correct" className="anim-wrap" />
      </div>
    </div>
  );

};

export default OXPopup;
